import { hasPricingAndPurchasingSucceededSelector } from './LoadingStateSelectors';
import { availableTermsForSkuSelector, commonAvailableTermsSelector, crmSuiteAvailableTermsSelector } from './OfferSelectors';
import { hasProductLevelOrHigherInProductInventorySelector } from './ProductInventorySelectors';
import { currentSuiteSkuIdsForProductLevelSelector, getIsTBSkuSelector, productForSkuIdSelector } from './ProductsSelectors';
export const shouldShowTermSelectorForMerchSelector = (state, {
  skuId
}) => {
  const hasPricingAndPurchasingSucceeded = hasPricingAndPurchasingSucceededSelector(state);
  if (!hasPricingAndPurchasingSucceeded) return false;
  const availableTerms = availableTermsForSkuSelector(state, {
    skuId
  });
  const hasTwoTerms = availableTerms.length > 1;
  const {
    productLine,
    productLevel
  } = productForSkuIdSelector(state, {
    skuId
  }) || {};
  const ownsProductOrHigher = hasProductLevelOrHigherInProductInventorySelector(state, {
    productLine,
    productLevel
  });
  return hasTwoTerms && !ownsProductOrHigher;
};
export const shouldShowTermSelectorForSuiteSelector = (state, {
  productLevel
}) => {
  const hasPricingAndPurchasingSucceeded = hasPricingAndPurchasingSucceededSelector(state);
  if (!hasPricingAndPurchasingSucceeded) return false;
  const skuIds = currentSuiteSkuIdsForProductLevelSelector(state, {
    productLevel
  });
  const isSuiteBundle = (skuIds === null || skuIds === void 0 ? void 0 : skuIds.length) === 1 && getIsTBSkuSelector(state, {
    skuId: skuIds[0]
  });
  const availableTerms = isSuiteBundle ? commonAvailableTermsSelector(state, {
    skuIds
  }) : crmSuiteAvailableTermsSelector(state, {
    productLevel
  });
  const hasMultipleTerms = availableTerms.length > 1;
  return hasMultipleTerms;
};